'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:selectDateStudent');
}

var _invoke = require('../invoke');

/**
 * 选择出行日期
 *
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof train
 * @static
 * @name selectDateStudent
 * @param {Object} opts 选项
 * @return {Promise<date>}
 * @example
 *  hbnb.train.selectDateStudent({
 *      date: '2015-10-19',
 *      days: 60,
 *      range: [{
 *          start: '2015-10-20',
 *          finish: '2015-12-30'
 *      }],
 *      tips: '预售期为60天，60天外不可购买'
 *  })
 *      .then(function(date) {
 *          date = '2015-12-13'
 *      });
 */
module.exports = function(opts) {
    if (process.env.NODE_ENV !== 'production') {
        debug('opts is %j', opts);
    }

    var p = new Promise(function(resolve, reject) {
        opts.callback = function(date) {
            resolve(date.date);
        };
        _invoke('train', 'select_date_student', opts);
    });
    return p;
};




//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/select-date-student.js
// module id = 634
// module chunks = 0